import { useEffect } from "react";
import { notification } from "antd";

import { registerNotificationApi } from "./notify.js";

/**
 * Renders the container for notify.success/notify.error pop-ups.
 * Mount once, near the root of the app (replaces react-s-alert's <Alert/>).
 */
export default function NotificationHost() {
	const [api, contextHolder] = notification.useNotification({
		placement: "topRight",
		maxCount: 5,
	});

	useEffect(() => {
		registerNotificationApi(api);
		return () => registerNotificationApi(null);
	}, [api]);

	return contextHolder;
}
